import React from "react";
import { ReactComponent as AfterHero } from "../../../assets/images/AfterHero.svg";
import { ReactComponent as GroupIcon } from "../../../assets/icons/group.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar.svg";
import { ReactComponent as FreeIcon } from "../../../assets/icons/free.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ClockIcon } from "../../../assets/icons/clock.svg";
const features = [
  {
    statement: "Individuals join classes with a few close accountability friends.",
    icon: <GroupIcon />,
  },
  {
    statement: "Participants meet once a month for seven months.",
    icon: <CalendarIcon />,
  },
  {
    statement: "Date and time are pre-planned and predictable to make attendance easy.",
    icon: <ClockIcon />,
  },
  {
    statement:
      "Course offered free of charge in partnership with sponsoring church.",
    icon: <FreeIcon />,
  },
];

const MoreAboutCBR = () => {

  const navigate = useNavigate();

  return (
    <div className="w-full bg-[#FDF8E7]">
      <div className="container mx-auto py-16">
        <div className="flex flex-col lg:flex-row items-center justify-between w-full">
          <div className="lg:w-1/2">
            <AfterHero className="w-[293px] h-[320px] md:w-[393px] md:h-[420px] lg:w-[493px] lg:h-[520px]" />
          </div>

          <div className="lg:w-1/2 space-y-6">
            <div>
              <p className="text-lighterYellow text-xl font-medium mb-2">About CBR</p>
              <h2 className="text-3xl font-light text-gray-900 mb-4">
                How we are Establishing Christians as Consistent Bible Readers
              </h2>
              <p className="text-gray-600 font-light mb-8">
                CBR is a discipline-establishing and habit-forming training designed to enable
                believers to develop a daily, systematic Bible-reading lifestyle in just seven months with the goal
                of finishing the Bible once every year.
              </p>
            </div>

            <div className="flex flex-wrap gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex flex-col  w-[calc(50%-12px)]">
                  <div className="mb-2 rounded-full">{feature.icon}</div>
                  <p className="text-gray-600 lg:w-[220px] font-light text-sm">
                    {feature.statement}
                  </p>
                </div>
              ))}
            </div>

            <button className="mt-8 px-2 py-2 md:px-4 md:py-3 lg:px-6 lg:py-4 bg-textBlue text-darkGrey rounded-full font-medium " onClick={() => navigate("/cbr-program")}>
              Learn about CBR Program
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoreAboutCBR;
